import { SelectProps } from 'antd';

export const filterOptionSelect: SelectProps['filterOption'] = (inputValue, option) => {
  return `${option?.children}`?.toLowerCase().includes(inputValue.toLowerCase());
};